import type { ClientFacingQuotation } from "./types";

export function getAssignmentInitialization({
  opening,
  activeOpening,
  initializedOpening,
  dirty,
  assignedClientIds,
  successful,
}: {
  opening: number;
  activeOpening: number;
  initializedOpening: number;
  dirty: boolean;
  assignedClientIds: string[];
  successful: boolean;
}) {
  if (
    opening === 0 ||
    opening !== activeOpening ||
    opening === initializedOpening ||
    dirty ||
    !successful
  ) {
    return null;
  }
  return new Set(assignedClientIds);
}

export function isCurrentQuotationOperation({
  quotationId,
  activeQuotationId,
  generation,
  activeGeneration,
}: {
  quotationId: string;
  activeQuotationId: string;
  generation: number;
  activeGeneration: number;
}) {
  return quotationId === activeQuotationId && generation === activeGeneration;
}

export function getCuritibaDate(date = new Date()) {
  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: "America/Sao_Paulo",
  }).format(date);
}

export function reconcilePublicationId(
  publications: ClientFacingQuotation[],
  currentId: string,
  today: string,
) {
  if (publications.some((publication) => publication.id === currentId)) {
    return currentId;
  }
  return (
    publications.find((publication) => publication.date.slice(0, 10) === today)
      ?.id ??
    publications[0]?.id ??
    ""
  );
}

export function isQuotationDatePast(date: string, today: string) {
  return date.slice(0, 10) < today;
}
